import { formatINRCompact } from "../../lib/currency";

/** Shared row/column axis builders for Ready Reckoners (Task 15.2) — a fixed list of values plus
 * a display formatter, so each reckoner config only needs to pick its own value ranges. */
export const currencyAxis = (label, values) => ({ label, values, format: (v) => formatINRCompact(v) });
export const yearsAxis = (label, values) => ({ label, values, format: (v) => `${v}y` });
export const monthsAxis = (label, values) => ({ label, values, format: (v) => `${v}m` });
